import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent } from "../../../common/component/Index";
import VinWonderTicketItems from './../../../../../models/VinWonderTicketItems';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import { PATHS } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import * as vinWonderTicketActions from './../../../../../actions/vinWonderTicketAction';
import { ticketTypes } from '../../../../../models/VinWonderTicketItems';
import VinWonderTicketItemDetail from './VinWonderTicketItemDetail';

import './VinWonderTicketItem.less';

const ListCols = ['ticketType', 'rateCode', 'refId', 'originalPrice', 'salePrice'];
const ModelFields = Object.getOwnPropertyNames(new VinWonderTicketItems());

class VinWonderTicketItemList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                ticketType: {
                    key: 'ticketType',
                    render: (text, record) => {
                        return {...ticketTypes.find(item => item.value === text)}.text
                    }
                },
                rateCode: {
                    key: 'rateCode',
                    render: (text, record) => text
                },
                refId: {
                    key: 'refId',
                    render: (text, record) => text
                },
                originalPrice: {
                    key: 'originalPrice',
                    render: (text, record) => Func.formatMoney(text)
                },
                salePrice: {
                    key: 'salePrice',
                    render: (text, record) => Func.formatMoney(text)
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
            detailItemOpening: false,
            itemSelected: undefined
        };
    }

    render() {
        const { t, loading, pagination, vinWonderTicketItems, vinWonderTicketId } = this.props;
        const { titleItemTable, modelItem, componentTable, detailItemOpening, itemSelected } = this.state;

        return (
            <div>
                <ListComponent
                    tableKey="vinWonderTicketItems-list"
                    classChildren="p-0" classParent="m-0"
                    title={() => (
                        <div className="heading-table">
                            <h6>{t(`item.vinWonderTicketItem.title`)}</h6>
                            <button onClick={this.createItem} className='btn btn-primary'>+ {t(`action.create`)}</button>
                        </div>
                    )}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(vinWonderTicketItems || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'vinWonderTicketItem'
                    })}
                    onChange={this.props.onChange}
                    hideSettings={true}
                />
                
                    <VinWonderTicketItemDetail 
                        visible={detailItemOpening}
                        itemSelected={itemSelected}
                        vinWonderTicketId={vinWonderTicketId}
                        vinWonderTicketItems={vinWonderTicketItems}
                        onSubmit={this.closeModal}
                        onCancel={this.closeModal} />
            </div>
        );
    }

    closeModal = () => {
        this.setState({ detailItemOpening: false, itemSelected: undefined })
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeVinWonderTicketItem = () => {
            this.props.deleteVinWonderTicketItemDetail && this.props.deleteVinWonderTicketItemDetail(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.vinWonderTicketItem.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeVinWonderTicketItem,
            });
        };

        const onClickOpenDetail = () => {
            this.setState({ detailItemOpening: true, itemSelected: item.id });
        }

        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                            <Menu.Item onClick={onClickOpenDetail}><Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}</Menu.Item>
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    createItem = () => {
        this.setState({ detailItemOpening: true });
    }

    getTableColumns() {
        return Func.getTitleTable(ListCols, ['action'], []);
    }

    componentDidMount(){
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteVinWonderTicketItemDetail: (vinWonderTicketItem) => dispatch(vinWonderTicketActions.deleteVinWonderTicketItemDetail(vinWonderTicketItem)),
    }
};

export default withTranslation()(connect(null, mapDispatchToProps)(VinWonderTicketItemList));
